import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import jsPDF from "jspdf";
import Postpal_Logo from "../../assets/images/home.png";
import { toast } from "react-toastify";

export const generatePdf = async (itemId) => {
  try {
    let conditionData = {};
    const formDataRef = doc(db, "forms", itemId);
    const docSnap = await getDoc(formDataRef);
    if (docSnap.exists()) {
      conditionData = docSnap.data()?.ConditionForm;
    }
    const document = new jsPDF();
    const pageWidth = document.internal.pageSize.getWidth(); // Get the page width

    // Add the logo image centered at the top
    const logoWidth = (48 * 25.4) / 96;
    const logoHeight = (48 * 25.4) / 96;
    const logoXPosition = (pageWidth - logoWidth) / 2;
    const logoYPosition = 20;

    document.addImage(
      Postpal_Logo,
      "PNG",
      logoXPosition,
      logoYPosition,
      logoWidth,
      logoHeight
    );

    // Set font size for the title
    document.setFontSize(18);

    // Center the title manually by calculating half the page width and offset for the string
    const title = "POSTPAL Conditional Report";
    document.text(title, pageWidth / 2, logoYPosition + logoHeight + 10, {
      align: "center",
    });

    // Set font size for the rest of the document
    document.setFontSize(12);

    const tHeader = [
      [{ content: "Item Name" }, { content: conditionData?.productname }],
      [{ content: "Package ID" }, { content: conditionData?.ordernumber }],
      [{ content: "Item ID" }, { content: conditionData?.productid }],
      [{ content: "Store Name" }, { content: conditionData?.storename }],
    ];

    document.autoTable({
      startY: logoYPosition + logoHeight + 10 + 10,
      margin: 40,
      body: tHeader,
      theme: "grid",
      styles: {
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
      headStyles: {
        lineWidth: 0.3,
        fontStyle: "bold",
      },
      bodyStyles: {
        fontStyle: "bold",
      },
      columnStyles: {
        0: { cellWidth: 80 },
        1: { cellWidth: 50 },
      },
    });

    const tBody = [
      [
        {
          content:
            "In your view, is the package description the same as the item inside the box?",
        },
        {
          content: conditionData?.conditionPackage === true ? "Yes" : "No",
        },
      ],
      [
        { content: "Serial number on box" },
        { content: conditionData?.serialnumberBox },
      ],
      [
        { content: "Serial number from on the product" },
        {
          content: conditionData?.serialnumberProduct,
        },
      ],
      [
        { content: "Serial number from on software information page" },
        {
          content: conditionData?.serialnumberInformation,
        },
      ],
      [
        {
          content:
            "What is the color of the item as specified in the packaging?",
        },
        {
          content: conditionData?.packingColor,
        },
      ],
      [
        {
          content:
            "What is the color of the item in your view or as detected by your tool?",
        },
        {
          content: conditionData?.packingTool,
        },
      ],
      [
        {
          content: "Any signs of damage to the outer box or packaging?",
        },
        {
          content: conditionData?.packageDamage === false ? "No" : "Yes",
        },
      ],
      [
        { content: "Any signs of damage to the item?" },
        {
          content: conditionData?.packagingCheck === false ? "No" : "Yes",
        },
      ],
      [
        { content: "Would you consider this New, Used, or Refrubrished?" },
        {
          content: conditionData?.status,
        },
      ],
      [
        { content: "Any stains to the items?" },
        { content: conditionData?.strainItems },
      ],
    ];

    document.autoTable({
      startY: document.previousAutoTable.finalY + 10,
      margin: 40,
      head: [["Question", "Details"]],
      body: tBody,
      theme: "grid",
      styles: {
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
      headStyles: {
        fillColor: ["#5E17EB"],
        textColor: ["#ffffff"],
        lineWidth: 0.3,
      },
      columnStyles: {
        0: { cellWidth: 80 },
        1: { cellWidth: 50 },
      },
      didParseCell: function (data) {
        if (data.section === "body" && data.column.index === 0) {
          // Set font style to bold for the first cell in each row
          data.cell.styles.fontStyle = "bold";
        }
      },
    });

    const tFooter = [
      [
        { content: "comments and feedback" },
        {
          content: conditionData?.commentFeedback,
        },
      ],
      [
        { content: "Report is prepared onbehalf of" },
        { content: conditionData?.userName },
      ],
      [
        { content: "Report is completed by" },
        { content: conditionData?.adminName },
      ],
      [
        {
          content: "Inspection report number",
        },
        {
          content: conditionData?.inspectionReport,
        },
      ],
    ];

    document.autoTable({
      startY: document.previousAutoTable.finalY + 10,
      margin: 40,
      body: tFooter,
      theme: "grid",
      styles: {
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
      headStyles: {
        lineWidth: 0.3,
        // fontStyle: "bold",
      },
      // bodyStyles: {
      //   fontStyle: "bold",
      // },
      columnStyles: {
        0: { cellWidth: 80 },
        1: { cellWidth: 50 },
      },
      didParseCell: function (data) {
        if (data.section === "body" && data.column.index === 0) {
          // Set font style to bold for the first cell in each row
          data.cell.styles.fontStyle = "bold";
        }
      },
    });

    const getImageType = (url) => {
      const extension = url.split(".").pop().split("?")[0];
      if (extension === "png") return "PNG";
      if (extension === "jpg" || extension === "jpeg") return "JPEG";
      if (extension === "gif") return "GIF";

      return "PNG";
    };

    const fetchImageAsBase64 = async (url) => {
      const response = await fetch(url);
      if (response.status === 200) {
        const blob = await response.blob();
        const reader = new FileReader();
        return new Promise((resolve, reject) => {
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      }
    };

    const prepareImages = async () => {
      const imageUrls = conditionData?.conditionUploadImg || [];

      const images = await Promise.all(
        imageUrls.map((url) => fetchImageAsBase64(url))
      );
      return images;
    };

    const base64Images = await prepareImages();

    // Add each image on a separate page
    base64Images.forEach((image, index) => {
      if (image) {
        document.addPage();
        const imageWidth = 50; // Fixed width for images
        const imageHeight = 50; // Fixed height for images
        const xPosition =
          (document.internal.pageSize.getWidth() - imageWidth) / 2;
        const yPosition = 20; // Margin from the top

        // Add title for the image page
        document.setFontSize(16);
        document.text(
          "Uploaded Images",
          document.internal.pageSize.getWidth() / 2,
          10,
          {
            align: "center",
          }
        );

        document.addImage(
          image,
          getImageType(conditionData?.conditionUploadImg[index]),
          xPosition,
          yPosition,
          imageWidth,
          imageHeight
        );
      }
    });
    const blob = document.output("blob");
    const url = URL.createObjectURL(blob);
    await updateDoc(formDataRef, {
      ConditionForm: {
        ...conditionData,
        isDocGenerated: true,
        docUrl: url,
      },
    }).then(() => {
      toast.success("Document Generated Successfully");
    });
    // document.save("conditional-report.pdf");
  } catch (error) {
    console.error("Failed to generate PDF", error);
  }
};
